import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} viewBox="0 0 17 20" xmlns="http://www.w3.org/2000/svg" style={{
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }}><path d="M8.634.002C10.438 5.826 6.985 12.374 0 19.407 10.302 15.823 16.542 9.791 16.812 0L8.634.002z" style={{
      fill: "#fff"
    }} /></svg>;
}
export default SvgComponent;